import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Switch, Space, Slider, Spin, Button } from "antd";
import ControllerPicture from "../picture/controller";
import apipostAc from "../../api/controller/postAc";

import { getcontroller, setshowCtlStored } from "../../stored/mydata";

export default function AirAllInOne(props) {
  const dispatch = useDispatch();

  const dataController = useSelector(getcontroller);
  const [dataDevice, setDataDevice] = useState(props.data);

  useEffect(() => {}, [dataDevice]);

  useEffect(() => {
    if (dataDevice["mac"] === dataController["mac"]) {
      setDataDevice({
        ...dataDevice,
        device_temp:
          dataController["temp"] === "error" ? "" : dataController["temp"],
        device_mode: dataController["mode"],
        device_fanspeed: dataController["speed"],
        device_status: dataController["status"],
        device_sweep: dataController["sweep"],
      });
      // dataDevice["device_temp"] = dataController["temp"] === "error" ? "" : dataController["temp"];
      // dataDevice["device_mode"] = dataController["mode"];
      // dataDevice["device_fanspeed"] = dataController["speed"];
      // dataDevice["device_status"] = dataController["status"];
      // dataDevice["device_sweep"] = dataController["sweep"];
    }
  }, [dataController]);

  const fanspeed = (value) => {
    if (value === "auto") {
      return 0;
    } else if (value === "quiet") {
      // quiet แบบเงียบ
      return 20;
    } else if (value === "low") {
      return 40;
    } else if (value === "medium") {
      return 60;
    } else if (value === "high") {
      return 80;
    } else if (value === "super_high") {
      // super high
      return 100;
    } else {
      return 0;
    }
  };

  const marksBtnFan = [
    {
      value: 0,
      nameBtn: "Auto",
    },
    {
      value: 20,
      nameBtn: "Quiet",
    },
    {
      value: 40,
      nameBtn: "Low",
    },
    {
      value: 60,
      nameBtn: "Mid",
    },
    {
      value: 80,
      nameBtn: "High",
    },
    {
      value: 100,
      nameBtn: "Super",
    },
  ];

  const apiControll = (value) => {
    // dispatch(setshowCtlStored(true));

    // device_brightness: null;
    // device_endpoint_status: null;
    // device_fanspeed: "medium";
    // device_gang: null;
    // device_group: null;
    // device_id: "ac";
    // device_mode: null;
    // device_model: "allinone";
    // device_name: "Air Condition Bedroom";
    // device_status: "on";
    // device_sweep: "on";
    // device_temp: "24";
    // device_type: "ac";

    const data_api = JSON.stringify(value);

    apipostAc(data_api, (err, res) => {
      if (res["message"] === "Success") {
        if (value.fn === "status") {
          setDataDevice({ ...dataDevice, device_status: value.val });
        } else if (value.fn === "temp") {
          setDataDevice({ ...dataDevice, device_temp: value.val });
        } else if (value.fn === "mode") {
          setDataDevice({ ...dataDevice, device_mode: value.val });
        } else if (value.fn === "speed") {
          setDataDevice({ ...dataDevice, device_fanspeed: value.val });
        } else if (value.fn === "sweep") {
          setDataDevice({ ...dataDevice, device_sweep: value.val });
        }

        // var count_time = 3;
        // let timerId = setInterval(() => {
        //   count_time--;

        //   if (count_time === 0) {
        //     dispatch(setshowCtlStored(false));
        //     clearInterval(timerId);
        //   }
        // }, 1000);
      }
    });
  };

  const controllerSwitch = (e) => {
    var data = {
      mac: dataDevice["mac"],
      device_id: dataDevice["device_id"],
      device_model: dataDevice["device_model"],
      device_type: dataDevice["device_type"],
      fn: "status",
      val: e,
    };

    if (e) {
      data["val"] = "on";
    } else {
      data["val"] = "off";
    }

    apiControll(data);
  };

  const controllerTemp = (value) => {
    const number = parseInt(dataDevice["device_temp"]) + value;

    var data = {
      mac: dataDevice["mac"],
      device_id: dataDevice["device_id"],
      device_model: dataDevice["device_model"],
      device_type: dataDevice["device_type"],
      fn: "temp",
      val: `${number}`,
    };

    if (number >= 18 && number <= 32) {
      apiControll(data);
    }
  };

  // const controllerMode = (value) => {
  //   // console.log(value);
  //   var data = {
  //     mac: dataDevice["mac"],
  //     device_id: dataDevice["device_id"],
  //     device_model: dataDevice["device_model"],
  //     device_type: dataDevice["device_type"],
  //     fn: "mode",
  //     val: value.toLowerCase(),
  //   };
  //   apiControll(data);
  // };

  const controllerSpeed = (value) => {
    var data = {
      mac: dataDevice["mac"],
      device_id: dataDevice["device_id"],
      device_model: dataDevice["device_model"],
      device_type: dataDevice["device_type"],
      fn: "speed",
      val: "",
    };

    if (value === 0) {
      data["val"] = "auto";
    } else if (value === 20) {
      data["val"] = "quiet";
    } else if (value === 40) {
      data["val"] = "low";
    } else if (value === 60) {
      data["val"] = "medium";
    } else if (value === 80) {
      data["val"] = "high";
    } else if (value === 100) {
      data["val"] = "super_high";
    } else {
      data["val"] = "auto";
    }

    apiControll(data);
  };

  const controllerSwing = (value) => {
    var data = {
      mac: dataDevice["mac"],
      device_id: dataDevice["device_id"],
      device_model: dataDevice["device_model"],
      device_type: dataDevice["device_type"],
      fn: "sweep",
      val: value,
    };

    apiControll(data);
  };

  return (
    <div>
      <div
        style={
          dataDevice["device_status"] === "on"
            ? styles.cardAir
            : styles.cardAiroff
        }
      >
        <Row gutter={[12, 12]}>
          <Col
            span={5}
            style={{ width: "250px" }}
            onClick={() => {
              if (dataDevice["device_status"] === "on") {
                controllerSwitch(false);
              } else {
                controllerSwitch(true);
              }
            }}
          >
            {ControllerPicture.air()}
          </Col>
          <Col span={19}>
            <Row>
              <Col
                span={15}
                onClick={() => {
                  if (dataDevice["device_status"] === "on") {
                    controllerSwitch(false);
                  } else {
                    controllerSwitch(true);
                  }
                }}
              >
                <div
                  style={
                    dataDevice["device_status"] === "on"
                      ? styles.fontHead
                      : styles.fontHeadoff
                  }
                >
                  Air Conditioner
                </div>
              </Col>
              <Col span={9} style={{ textAlign: "end", paddingTop: "3px" }}>
                <Space direction="vertical" style={{ marginLeft: "23%" }}>
                  <Switch
                    // size="small"
                    // checked={checked} onChange={setChecked}
                    onChange={controllerSwitch}
                    checked={
                      dataDevice["device_status"] === "on" ? true : false
                    }
                    checkedChildren="ON"
                    unCheckedChildren="OFF"
                  />
                </Space>
              </Col>
            </Row>
            <div style={{ marginTop: "2%" }}>
              <Row>
                <Col span={8} style={{ width: "250px", textAlign: "center" }}>
                  {dataDevice["device_mode"] !== "fan" &&
                  dataDevice["device_status"] === "on" ? (
                    <div
                      onClick={() => {
                        controllerTemp(-1);
                      }}
                    >
                      {ControllerPicture.minus()}
                    </div>
                  ) : (
                    <div>{ControllerPicture.minusD()}</div>
                  )}
                </Col>
                <Col span={8} style={styles.fontNumber}>
                  {dataDevice["device_temp"]}°
                </Col>
                <Col span={8} style={{ width: "250px", textAlign: "center" }}>
                  {dataDevice["device_mode"] !== "fan" &&
                  dataDevice["device_status"] === "on" ? (
                    <div
                      onClick={() => {
                        controllerTemp(1);
                      }}
                    >
                      {ControllerPicture.plus()}
                    </div>
                  ) : (
                    <div>{ControllerPicture.plusD()}</div>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        {/* Start Mode Fan */}
        <Row>
          <Col span={5}>
            <Row>
              <Col span={12} style={{ width: "200px" }}>
                {ControllerPicture.wind()}
              </Col>
              <Col span={12}>
                <div style={styles.fontInpage}>Fan</div>
              </Col>
            </Row>
          </Col>
        </Row>
        <div
          style={
            dataDevice["device_status"] === "on"
              ? styles.cardInerv
              : styles.cardInervoff
          }
        >
          {dataDevice["device_status"] === "on" ? (
            <div>
              <Row gutter={[16, 8]} justify="center" align="middle">
                {marksBtnFan.map((item) => (
                  <Col key={item.value} span={4}>
                    <div
                      style={
                        item.value === fanspeed(dataDevice["device_fanspeed"])
                          ? styles.btnFanChoose
                          : styles.btnFan
                      }
                      onClick={() => controllerSpeed(item.value)}
                    >
                      {item.nameBtn}
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          ) : (
            <div>
              <Row gutter={[16, 8]} justify="center" align="middle">
                {marksBtnFan.map((item) => (
                  <Col key={item.value} span={4}>
                    <div
                      style={
                        item.value === fanspeed(dataDevice["device_fanspeed"])
                          ? styles.btnFanChooseOff
                          : styles.btnFanOff
                      }
                    >
                      {item.nameBtn}
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          )}
        </div>
        {/* End Mode Fan */}

        {/* Start Mode Swing */}
        {dataDevice["device_status"] === "on" ? (
          <div>
            <Row gutter={[16, 8]} justify="center" align="middle">
              <Col span={11}>
                <Row gutter={[16, 4]}>
                  <Col span={16}>
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      {ControllerPicture.fanSwing()}
                    </div>
                  </Col>
                  <Col span={8}>
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                      }}
                    >
                      Swing
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={13}>
                <Row>
                  <Col span={12}>
                    <div style={styles.textInbtn}>
                      <div
                        style={
                          dataDevice["device_sweep"] === "off"
                            ? styles.btnSwingChoose
                            : styles.btnSwing
                        }
                        onClick={() => {
                          controllerSwing("off");
                        }}
                      >
                        {ControllerPicture.fanStop()}
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          marginTop: "8px",
                          fontWeight: "500",
                        }}
                      >
                        Stop
                      </div>
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={styles.textInbtn}>
                      <div
                        style={
                          dataDevice["device_sweep"] === "on"
                            ? styles.btnSwingChoose
                            : styles.btnSwing
                        }
                        onClick={() => {
                          controllerSwing("on");
                        }}
                      >
                        {ControllerPicture.fanSwing()}
                      </div>
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        marginTop: "8px",
                        fontWeight: "500",
                      }}
                    >
                      Swing
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        ) : (
          <div>
            <Row gutter={[16, 8]} justify="center" align="middle">
              <Col span={11}>
                <Row gutter={[16, 4]}>
                  <Col span={16}>
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      {ControllerPicture.fanSwing()}
                    </div>
                  </Col>
                  <Col span={8}>
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                      }}
                    >
                      Swing
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={13}>
                <Row>
                  <Col span={12}>
                    <div style={styles.textInbtn}>
                      <div
                        style={
                          dataDevice["device_sweep"] === "off"
                            ? styles.btnSwingChooseOff
                            : styles.btnSwingOff
                        }
                      >
                        {ControllerPicture.fanStop()}
                      </div>
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        marginTop: "8px",
                        fontWeight: "500",
                      }}
                    >
                      Stop
                    </div>
                  </Col>
                  <Col span={12}>
                    <div style={styles.textInbtn}>
                      <div
                        style={
                          dataDevice["device_sweep"] === "on"
                            ? styles.btnSwingChooseOff
                            : styles.btnSwingOff
                        }
                      >
                        {ControllerPicture.fanSwing()}
                      </div>
                    </div>
                    <div
                      style={{
                        textAlign: "center",
                        marginTop: "8px",
                        fontWeight: "500",
                      }}
                    >
                      Swing
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )}
        {/* End Mode Swing */}
      </div>
    </div>
  );
}

const styles = {
  head: {
    backgroundColor: "#F0F9FB",
    height: "108px",
  },
  cardAir: {
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    gap: "12px",
    borderRadius: "16px",
    border: "1px solid #B5EAEF",
  },
  cardAiroff: {
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    gap: "12px",
    borderRadius: "16px",
    border: "1px solid #E3E3E3",
  },
  cardInerv: {
    flexShrink: "0",
    borderRadius: "16px",
    border: "1px solid #B5EAEF",
    background: "#FBFBFB",
    padding: "10px 15px 10px 8px",
  },
  cardInervoff: {
    flexShrink: "0",
    borderRadius: "16px",
    border: "1px solid #E3E3E3",
    background: "rgba(251, 251, 251, 0.1)",
    padding: "10px 15px 10px 8px",
  },
  fontInpage: {
    color: "#56585D",
    paddingTop: "2px",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  // fontInpageoff: {
  //   color: "#E3E3E3",
  //   paddingTop: "2px",
  //   fontFeatureSettings: "clig off, liga off",
  //   fontSize: "14px",
  //   fontStyle: "normal",
  //   fontWeight: "500",
  //   lineHeight: "21px",
  // },
  fontHead: {
    fontFamily: "Gotham",
    color: "#3EA8B8",
    textAlign: "center",
    paddingTop: "2px",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px",
  },
  fontHeadoff: {
    fontFamily: "Gotham",
    color: "#E3E3E3",
    textAlign: "center",
    paddingTop: "2px",
    fontFeatureSettings: "clig off, liga off",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "21px" /* 150% */,
  },
  fontNumber: {
    color: "#56585D",
    fontFamily: "Gotham",
    fontSize: "36px",
    fontStyle: "normal",
    fontWeight: "300",
    lineHeight: "32px",
    letterSpacing: "0.15px",
    textAlign: "center",
    marginTop: "10px",
  },
  textInbtn: {
    display: "flex",
    flexDirection: "column" /* เรียงแนวตั้ง */,
    justifyContent: "center" /* จัดกึ่งกลางแนวตั้ง */,
    alignItems: "center" /* จัดกึ่งกลางแนวนอน */,
    textAlign: "center",
  },
  btnFan: {
    display: "flex",
    width: "30px" /* ปรับให้ปุ่มใหญ่ขึ้น */,
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#FBFBFB",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    margin: "auto" /* จัดปุ่มให้อยู่กึ่งกลาง Col */,
    cursor: "pointer" /* ทำให้เป็น Cursor แบบคลิกได้ */,
  },
  btnFanChoose: {
    display: "flex",
    width: "30px",
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #B5EAEF",
    background: "#EBF4FA",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    fontWeight: "bold",
    margin: "auto" /* จัดปุ่มให้อยู่กึ่งกลาง Col */,
    cursor: "pointer" /* ทำให้เป็น Cursor แบบคลิกได้ */,
  },
  btnFanOff: {
    display: "flex",
    width: "30px" /* ปรับให้ปุ่มใหญ่ขึ้น */,
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#FBFBFB",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    margin: "auto" /* จัดปุ่มให้อยู่กึ่งกลาง Col */,
    cursor: "pointer" /* ทำให้เป็น Cursor แบบคลิกได้ */,
  },
  btnFanChooseOff: {
    display: "flex",
    width: "30px",
    height: "25px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#E3E3E3",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
    fontWeight: "bold",
    margin: "auto" /* จัดปุ่มให้อยู่กึ่งกลาง Col */,
    cursor: "pointer" /* ทำให้เป็น Cursor แบบคลิกได้ */,
  },
  btnSwing: {
    display: "flex",
    width: "40px",
    height: "40px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#FBFBFB",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
  },
  btnSwingChoose: {
    display: "flex",
    width: "40px",
    height: "40px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #B5EAEF",
    background: "#EBF4FA",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
  },
  btnSwingOff: {
    display: "flex",
    width: "40px",
    height: "40px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#FBFBFB",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
  },
  btnSwingChooseOff: {
    display: "flex",
    width: "40px",
    height: "40px",
    padding: "10px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    borderRadius: "14px",
    border: "1px solid #E3E3E3",
    background: "#E3E3E3",
    boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
  },
};
